import React from 'react'

import { RoutesPath } from 'src/types'

import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from 'src/components/shadcn/breadcrumb'
import { useAppBreadcrumb } from 'src/components/AppBreadcrumb/useAppBreadcrumb'
import { GenericBreadcrumbProps } from 'src/components/AppBreadcrumb/types'

const AppBreadcrumb = ({ items }: GenericBreadcrumbProps): JSX.Element => {
  const { navigateTo } = useAppBreadcrumb()

  return (
    <Breadcrumb>
      <BreadcrumbList>
        {items.map((item, index) => (
          <React.Fragment key={index}>
            <BreadcrumbItem>
              {item.href ? (
                <BreadcrumbLink
                  onClick={() => navigateTo(item.href as RoutesPath)}
                >
                  {item.labelKey}
                </BreadcrumbLink>
              ) : (
                <BreadcrumbPage>{item.labelKey}</BreadcrumbPage>
              )}
            </BreadcrumbItem>
            {index < items.length - 1 && <BreadcrumbSeparator />}
          </React.Fragment>
        ))}
      </BreadcrumbList>
    </Breadcrumb>
  )
}

export default AppBreadcrumb
